// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"B","modalContent":"C","header":"D","close":"E"};